import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const requestAccountURL = "/api/v1/RequestAccount/Submit";

export interface SubmitReuqestAccountFormApiParameter extends ApiParameter {
    companyName: string;
    companyStreetAddress: string;
    contactName: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    phoneNumberExt?: string; 
    emailAddress: string;
    positionTitle: string;
    typeOfBusiness: string;
    message?: string;
}

export interface TempReturn {
    success: boolean;
}

export function submitAccountRequest(parameter: SubmitReuqestAccountFormApiParameter) {
    return post<SubmitReuqestAccountFormApiParameter>(`${requestAccountURL}`, parameter);
}

// export const ThosSetDefaultWarehouse = async (parameter: SubmitReuqestAccountFormApiParameter) => {
//     try {
//         const result = await post<SubmitReuqestAccountFormApiParameter, TempReturn>(`${requestAccountURL}`, parameter);
//         return {
//             result,
//             successful: true,
//         };
//     } catch (error) {
//         if (isApiError(error) && error.status === 400) {
//             return {
//                 successful: false,
//                 errorMessage: "Something Went Wrong",
//             };
//         }
//         throw error;
//     }
// };